import { gql } from "@apollo/client";

export const GET_JOB = gql`
  query job($id: ID!) {
    job(id: $id) {
      id
      title
      approved_at
      job_type
      job_mode
      job_team_type
      description
      category {
        id
        name
      }
      industry {
        id
        name
      }
      qualification {
        id
        name
      }
      courses
      certificates
      skills
      state {
        id
        name
      }
      city {
        id
        name
      }
      country {
        id
        name
      }
      organization
      organization_logo
      created_by {
        id
        username
        organization {
          id
          name
        }
      }
      location
      positions
      salary_confidential
      minimum_remuneration
      maximum_remuneration
      perks
      minimum_experience
      maximum_experience
      minimum_year_of_passing
      maximum_year_of_passing
      gender_preference
      closure
      start_date
      duration
      confidential
      profile
      created_by {
        id
        first_name
        last_name
      }
      status
      number_of_views
      applied_count
      shortlisted_count
      interviewed_count
      selected_count
      offered_count
      joined_count
      rejected_count
      job_status
      is_saved
      updated_at
      created_at
      stipend_type
      languages {
        id
        language
        read
        write
        speak
      }
      publish_to
      job_campus {
        id
        campus {
          id
          name
        }
      }
      job_states {
        id
        state {
          id
          name
        }
      }
      number_of_views
    }
  }
`;

export const GET_JOBS_ARR = gql`
  query jobs(
    $filter: JobFilterInput
    $limit: Int
    $page: Int
    $sort_by: String
    $not_candidate: String
  ) {
    jobs(
      filter: $filter
      limit: $limit
      page: $page
      sort_by: $sort_by
      not_candidate: $not_candidate
    ) {
      count
      jobs {
        id
        title
      }
    }
  }
`;

export const EXPORT_APPLIED_CANDIDATES = gql`
  query export_applied_candidates {
    export_applied_candidates {
      status
      message
      report
    }
  }
`;

export const SEARCH_STUDENTS = gql`
  query search_candidates(
    $filter: SearchCandidateFilterInput
    $limit: Int
    $page: Int
    $sort_by: String
    $filter_by_job: Boolean
  ) {
    search_candidates(
      filter: $filter
      limit: $limit
      page: $page
      sort_by: $sort_by
      filter_by_job: $filter_by_job
    ) {
      count
      users {
        id
        first_name
        last_name
        profile
        profile_data
        document
        document_type
        email
        location
        city {
          id
          name
        }
        skills
        qualification {
          id
          qualification {
            id
            name
          }
          course {
            id
            name
          }
          specialization
          graduation_year
          college_percentage
        }
        work_experience {
          id
          start_date
          end_date
        }
        work_preference {
          id
          minimum_expectation
          maximum_expectation
        }
      }
    }
  }
`;
